const cartNotification = document.getElementById('cart-notification');

if (cartNotification) {
    let previousRawText = '';

    const listener = new MutationObserver(() => {
        setTimeout(() => {
            const subtotalElement = document.getElementById('cartNotificationSubtotal');
            if (!subtotalElement) return;

            const rawText = subtotalElement.textContent.trim();

            if (rawText !== previousRawText) {
                previousRawText = rawText;

                const validPricePattern = /^£\d+(\.\d{2})?$/;
                if (validPricePattern.test(rawText)) {
                    const numericString = rawText.replace(/[£,.]/g, '');
                    const amountInPence = parseInt(numericString, 10);

                    if (!isNaN(amountInPence)) {
                        const delivery_threshold = document.getElementById('countdown-to-delivery-bar').dataset.deliveryThreshold;
                        const new_threshold = delivery_threshold - amountInPence;
                        const percentage_remaining = Math.round((new_threshold / delivery_threshold) * 100);

                        let percent_complete = 100 - percentage_remaining;
                        if(percent_complete < 0) percent_complete = 0;
                        if(percent_complete > 100) percent_complete = 100;

                        const barFill = document.querySelector('#countdown-to-delivery-bar .bar__fill');
                        if (barFill) barFill.style.width = percent_complete + '%'; // Se
                        
                        const amountInPounds = '£' + (new_threshold / 100).toFixed(2);
                        const deliveryText = document.getElementById('countdown-to-delivery-text');
                        let deliveryMessage = deliveryText.dataset.messageToGo.replace('{}', amountInPounds);

                        if(percent_complete === 100) {
                            deliveryMessage = deliveryText.dataset.messageFull;
                        }

                        deliveryText.innerHTML = deliveryMessage;
                    }
                } else {
                    console.log('Subtotal text is not a valid price yet:', rawText);
                }
            }
        }, 50);
    });

    listener.observe(cartNotification, {
        childList: true,
        characterData: true,
        subtree: true
    });{}
}